
























export default {
  name: 'items-list',
  props: {
    items: Array,
    selectedIds: {
      type: Array,
      default: () => []
    },
    valueLabel: String
  },
  methods: {
    getItemCountText: function (item: any): string {
      let itemCountText = item.count.toLocaleString(this.$epb.locale);
      if (!!this.valueLabel) {
        itemCountText += ` ${ this.valueLabel }`;
      }
      return itemCountText;
    },
    hasPercentage: function (item: any): boolean {
      return (item.percentage !== undefined);
    },
    getItemPercentageText: function (item: any): string {
      return `(${ item.percentage.toLocaleString(this.$epb.locale, { maximumSignificantDigits: 3 }) }%)`;
    }
  }
};

